import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { PanelTitle } from '@atlassian/panel-system';

import type { PreviewPanelTitleProps } from './types';

export const PreviewPanelTitle = ({
	title,
	icon,
	color,
}: PreviewPanelTitleProps): React.JSX.Element => {
	if (fg('ads-panel-system-gpp')) {
		return <PanelTitle icon={icon}>{title}</PanelTitle>;
	}

	return (
		<Inline space="space.100" alignBlock="center">
			{icon}
			<Text weight="bold" maxLines={1} color={color}>
				{title}
			</Text>
		</Inline>
	);
};
